// CV Center API client.
import axios from "axios";
import { API } from "@/App";

const auth = (token) => ({ headers: token ? { Authorization: `Bearer ${token}` } : {} });

export const cvApi = {
  professions:    () => axios.get(`${API}/cv/professions`).then(r => r.data),
  templates:      () => axios.get(`${API}/cv/templates`).then(r => r.data),
  pricing:        () => axios.get(`${API}/cv/pricing`).then(r => r.data),
  sample:         (lang = "en") => axios.get(`${API}/cv/sample?lang=${lang}`).then(r => r.data),

  // Resumes (require token)
  list:    (token)             => axios.get(`${API}/cv/resumes`, auth(token)).then(r => r.data),
  get:     (id, token)         => axios.get(`${API}/cv/resumes/${id}`, auth(token)).then(r => r.data),
  create:  (body, token)       => axios.post(`${API}/cv/resumes`, body, auth(token)).then(r => r.data),
  update:  (id, body, token)   => axios.put(`${API}/cv/resumes/${id}`, body, auth(token)).then(r => r.data),
  remove:  (id, token)         => axios.delete(`${API}/cv/resumes/${id}`, auth(token)).then(r => r.data),

  // AI
  aiSummary:      (body, token) => axios.post(`${API}/cv/ai/summary`, body, auth(token)).then(r => r.data),
  aiBullets:      (body, token) => axios.post(`${API}/cv/ai/bullets`, body, auth(token)).then(r => r.data),
  aiSkills:       (body, token) => axios.post(`${API}/cv/ai/skills`, body, auth(token)).then(r => r.data),
  aiAchievements: (body, token) => axios.post(`${API}/cv/ai/achievements`, body, auth(token)).then(r => r.data),
  aiStrengths:    (body, token) => axios.post(`${API}/cv/ai/strengths`, body, auth(token)).then(r => r.data),

  // Phase 2
  coverLetter: (body, token) => axios.post(`${API}/cv/cover-letter/generate`, body, auth(token)).then(r => r.data),
  atsAnalyze:  (body, token) => axios.post(`${API}/cv/ats/analyze`, body, auth(token)).then(r => r.data),

  // Phase 3
  interview:    (slug, lang="ar") => axios.get(`${API}/cv/interview/${slug}?lang=${lang}`).then(r => r.data),
  salary:       (slug, state="")  => axios.get(`${API}/cv/salary/${slug}${state?`?state=${state}`:""}`).then(r => r.data),
  careerAdvice: () => axios.get(`${API}/cv/career-advice`).then(r => r.data),

  // Phase 4 — AI Wizard + Translate + Pre-download Review
  wizardSteps:    (lang = "ar")   => axios.get(`${API}/cv/wizard/steps?lang=${lang}`).then(r => r.data),
  wizardGenerate: (body, token)   => axios.post(`${API}/cv/wizard/generate`, body, auth(token)).then(r => r.data),
  translate:      (body, token)   => axios.post(`${API}/cv/translate`, body, auth(token)).then(r => r.data),
  review:         (body, token)   => axios.post(`${API}/cv/review`, body, auth(token)).then(r => r.data),
};

// Empty resume scaffold used for "New Resume".
export const emptyResume = () => ({
  title: "My Resume",
  profession: "",
  template: "professional",
  data: {
    contact: { full_name: "", title: "", email: "", phone: "", location: "", linkedin: "", website: "", photo: "" },
    summary: "",
    experience: [],
    education: [],
    skills: [],
    languages: [],
    certifications: [],
    projects: [],
    achievements: [],
    options: {},
  },
});
